export const sortType = {
    default: "recommendation",
    priceAsc: "priceLowToHigh",
    priceDesc: "priceHighToLow"
};